"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var r = require('styled-components');
var reactSlider = require('@radix-ui/react-slider');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var r__default = /*#__PURE__*/_interopDefaultLegacy(r);

var e=r__default["default"](reactSlider.Track)`
  background-color: var(--color-neutral-300);
  position: relative;
  flex-grow: 1;
  border-radius: 9999px;

  &[data-orientation='horizontal'] {
    height: var(--spacing-small);
  }
`,i=r__default["default"](reactSlider.Thumb)`
  display: block;
  background-color: var(--color-blurple-600);
  border: 2px solid var(--color-neutral-0);
  width: 16px;
  height: 16px;
  border-radius: 16px;
  box-sizing: content-box;

  &:hover {
    background-color: var(--color-blurple-700);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px var(--color-blue-600);
  }

  &:active:focus {
    border: 2px solid var(--color-blurple-400);
    box-shadow: 0 0 0 2px var(--color-blurple-400);
  }

  &[data-disabled] {
    border: 2px solid var(--color-neutral-300);
    background-color: var(--color-neutral-500);
  }
`,x=r.css`
  min-width: 174px;

  &[data-orientation='horizontal'] {
    height: var(--spacing-x-small);
  }

  ${e} {
    &[data-orientation='horizontal'] {
      height: var(--spacing-x-small);
    }
  }

  ${i} {
    width: 12px;
    height: 12px;
    border-radius: 12px;
  }
`,a=r__default["default"](reactSlider.Root)`
  position: relative;
  display: flex;
  align-items: center;
  user-select: none;
  touch-action: none;
  min-width: 320px;
  ${({size:o})=>o==="small"&&x}

  &[data-orientation='horizontal'] {
    height: var(--spacing-small);
  }
`,t=r__default["default"](reactSlider.Range)`
  position: absolute;
  background-color: var(--color-blurple-600);
  border-radius: 9999px;
  height: 100%;

  &[data-disabled] {
    background-color: var(--color-neutral-500);
  }
`;var d=({size:o="small",...n})=>jsxRuntime.jsxs(a,{size:o,...n,children:[jsxRuntime.jsx(e,{children:jsxRuntime.jsx(t,{})}),jsxRuntime.jsx(i,{"aria-label":"Slider thumb"})]});d.displayName="Slider";var b=r__default["default"](d)``;

exports.a = b;
